import { useState } from "react";
import { feedHot, feedLatest, feedTalk, type FeedItem } from "@/mocks/home";

const tabs = [
  { key: "latest", label: "最新更新", data: feedLatest },
  { key: "hot", label: "热门阅读", data: feedHot },
  { key: "talk", label: "讨论最多", data: feedTalk },
];

function FeedCard({ item, index }: { item: FeedItem; index: number }) {
  return (
    <article
      className="animate-fade-up group rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-background-100 md:p-5"
      style={{ animationDelay: `${index * 50}ms` }}
    >
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
        <span className="whitespace-nowrap rounded-sm bg-secondary-100 px-2 py-0.5 font-medium text-secondary-900">
          {item.category}
        </span>
        <span className="whitespace-nowrap">{item.time}</span>
        <span className="hidden items-center gap-1 sm:flex">
          <i className="ri-chat-3-line w-3.5 h-3.5 flex items-center justify-center text-xs" />
          {item.comments}
        </span>
      </div>

      <h3 className="mt-2.5 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
        {item.title}
      </h3>
      <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
        {item.summary}
      </p>

      <div className="mt-4 flex items-center justify-between">
        <span className="flex items-center gap-1.5 text-xs font-semibold text-accent-600">
          <i className="ri-fire-line w-4 h-4 flex items-center justify-center text-sm" />
          热度 {item.heat}
        </span>
        <span className="flex items-center gap-1 text-xs font-medium text-foreground-500 transition-colors group-hover:text-primary-600">
          免费阅读全文
          <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center text-base" />
        </span>
      </div>
    </article>
  );
}

export default function LatestFeed() {
  const [active, setActive] = useState("latest");
  const current = tabs.find((tab) => tab.key === active) ?? tabs[0];

  return (
    <section id="latest" className="w-full bg-background-100">
      <div className="mx-auto w-full px-4 py-14 md:px-6 md:py-16">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
              <i className="ri-newspaper-line w-4 h-4 flex items-center justify-center text-sm" />
              Feed
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              最新吃瓜 · 标题先看，读不读你决定
            </h2>
            <p className="mt-2 max-w-xl text-sm leading-relaxed text-foreground-600">
              每条都配一句短摘要，扫一眼就知道要不要点开，零成本浏览不浪费时间。
            </p>
          </div>

          <div className="flex flex-wrap rounded-full border border-background-200 bg-background-50 p-1">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                onClick={() => setActive(tab.key)}
                className={
                  active === tab.key
                    ? "rounded-full bg-foreground-900 px-4 py-1.5 text-sm font-semibold text-background-50 transition-colors"
                    : "rounded-full px-4 py-1.5 text-sm font-medium text-foreground-600 transition-colors hover:text-foreground-900"
                }
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {current.data.map((item, index) => (
            <FeedCard key={item.id} item={item} index={index} />
          ))}
        </div>

        <div className="mt-8 flex justify-center">
          <a
            href="#topics"
            className="inline-flex h-11 items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            按话题浏览更多
            <i className="ri-arrow-down-line w-4 h-4 flex items-center justify-center text-base" />
          </a>
        </div>
      </div>
    </section>
  );
}